<template>
  <div class="loginAndRegister">
    <el-dialog
      :visible.sync="loginVisible"
      width="23%"
      :before-close="handleClose"
      id="loginDialog"
    >
      <div v-if="temp == 'dl'">
        <h3 class="loginTitle">登录</h3>
        <el-input v-model="loginForm.tel" placeholder="请输入登录名/手机号" @keyup.enter.native="loginUp" class="username"></el-input>
        <el-input type="password" autocomplete="new-password" v-model="loginForm.passwd" placeholder="请输入密码" @keyup.enter.native="loginUp" class="password"></el-input>
        <div class="passCheck">
          
        </div>
        <el-button type="primary" @click="loginUp">登 录</el-button>
        <div class="registe" @click="registePass">立即注册></div>
      </div>
      <div v-if="temp == 'zc'" class="zcBox">
        <h3 class="loginTitle">注册</h3>
        <span class="backLogin" @click="backLogin">已有账号，立刻登录></span>
        <el-form ref="zcForm" :model="zcForm" :rules="rules">
          <el-form-item prop="dw">
            <el-input v-model="zcForm.dw" placeholder="单位或个人" class="dw"></el-input>
          </el-form-item>
          <el-form-item prop="zctel">
            <el-input v-model="zcForm.zctel" placeholder="手机号" class="zcusername"></el-input>
          </el-form-item>
          <el-form-item prop="zcpass1">
            <el-input type="password" v-model="zcForm.zcpass1" placeholder="密码" class="zcpassword"></el-input>
          </el-form-item>
          <el-form-item prop="zcpass2">
            <el-input
              type="password"
              v-model="zcForm.zcpass2"
              placeholder="确认密码"
              class="zcpassword"
            ></el-input>
          </el-form-item>
        </el-form>

        <span style="color:red" v-if="zcForm.zcpass1!=zcForm.zcpass2">两次输入密码不一致</span>
        <!-- <div class="agreeOpt">
          <input type="checkbox" v-model="zcCheck"> 同意
          <span>"服务条款"</span>，
          <span>"用户须知"</span> 和
          <span>"隐私相关政策"</span>。
        </div>-->
        <el-button type="primary" @click="addUser" :disabled="zcForm.zcpass1!=zcForm.zcpass2 ">立即注册</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { zcCommit, loginCommit, getUser } from "@/api/jjdt/jjdt";
import { getToken } from "@/utils/auth";
import { validPassword } from "@/utils/validate";
import {mapGetters} from 'vuex';
let Base64 = require("js-base64").Base64;
export default {
  name: "loginAndRegister",
  components: {},
  data() {
    var checkPhone = (rule, value, callback) => {
      const phoneReg = /^1[3|4|5|6|7|8][0-9]{9}$/;
      if (!value) {
        return callback(new Error("电话号码不能为空"));
      }
      setTimeout(() => {
        if (!Number.isInteger(+value)) {
          callback(new Error("请输入数字值"));
        } else {
          if (phoneReg.test(value)) {
            callback();
          } else {
            callback(new Error("电话号码格式不正确"));
          }
        }
      }, 100);
    };
    const passWord = (rule, value, callback) => {
      if (!value) {
        callback(new Error("必填项"));
      } else if (!validPassword(value)) {
        callback(new Error("密码由6-20字母和数字组成"));
      } else {
        callback();
      }
    };
    return {
      zcForm: {},
      isCheck:false,
      loginForm:{},
      temp: "dl",
      rules: {
        jjrxm: [{ required: true, trigger: "blur", message: "该项不能为空" }],
        sfzhm: [{ required: true, trigger: "blur", message: "该项不能为空" }],
        qymc: [{ required: true, trigger: "blur", message: "该项不能为空" }],
        frdb: [{ required: true, trigger: "blur", message: "该项不能为空" }],
        zcdd: [{ required: true, trigger: "blur", message: "该项不能为空" }],
        tkzh: [{ required: true, trigger: "blur", message: "该项不能为空" }],
        lxdh: [{ required: true, trigger: "blur", message: "该项不能为空" }],
        lxdz: [{ required: true, trigger: "blur", message: "该项不能为空" }],
        bz: [{ required: true, trigger: "blur", message: "该项不能为空" }],
        khhmc: [{ required: true, trigger: "blur", message: "该项不能为空" }],
        zctel: [{ required: true, trigger: "blur", validator: checkPhone }],
        dw: [{ required: true, trigger: "blur", message: "该项不能为空" }],
        zcpass1: [{ required: true, trigger: "blur", validator: passWord }],
        zcpass2: [{ required: true, trigger: "blur", message: "该项不能为空" }]
      },
    };
  },
  computed: {
    ...mapGetters(['loginVisible'])
  },
  methods: {
    setCookie(c_name, c_pwd, exdays) {
      var exdate = new Date();
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays);
      window.document.cookie =
        "userName" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
      window.document.cookie =
        "userPwd" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
    },
    clearCookie: function() {
      this.setCookie("", "", -1);
    },
    //登录
    loginUp() {
      let _this = this;
      // if (this.isCheck) {
      // } else {
      //   this.clearCookie();
      // }
      if(!_this.loginForm.tel||!_this.loginForm.passwd){
        this.$message.error("账号或密码不能为空");
        return;
      }
      let obj = Object.assign({}, _this.loginForm);
      obj.passwd = Base64.encode(obj.passwd);
      _this.$store
        .dispatch("LoginByUsername", obj)
        .then(res => {
          if (res) {
            if (getToken()) {
              getUser("/uUserPortal/queryBytoken?token=" + getToken()).then(
                res => {
                  let data = res.data;
                  if (data.success) {
                    _this.$store.state.user.userId = data.data.uUserPortal.id;
                    this.$store.commit(
                      "SET_USER1",
                      data.data.uUserInfoPortal.xm
                    );
                    this.$store.commit(
                      "SET_USERNAME",
                      data.data.uUserPortal.nickname
                    );
                  }
                }
              );
            }
            this.$message({
              message: "登录成功",
              type: "success"
            });
            this.handleClose();
          }
        })
        .catch(error => {});
    },
    //注册
    addUser() {
      let obj = {};
      obj.uUserPortal = {
        tel: this.zcForm.zctel,
        password: Base64.encode(this.zcForm.zcpass2)
      };
      obj.uUserInfoPortal = {};
      let _this = this;
      let url = "/uUserPortal/SaveAndUpdateToUserPortalAndInfoPortal";
      this.$refs.zcForm.validate(valid => {
        if (valid) {
          zcCommit(url, obj).then(res => {
            let data = res.data;
            if (data.success) {
              _this.$message({
                message: "注册成功",
                type: "success"
              });
              _this.zcForm = {};
              _this.handleClose();
            }else{
               _this.$message({
                message: data.msg,
                type: "error"
              });
            }
          });
        }
      });
    },
    //切换
    registePass() {
      this.temp = "zc";
    },
    backLogin() {
      this.temp = "dl";
    },
    //关闭
    handleClose() {
      this.loginForm = {}
      this.temp = "dl";
      this.$store.commit('SET_LOGIN',false)
    },
  },
  created() {},
  mounted() {}
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.passCheck {
  height: 30px;
  color: #999;
  padding-top: 8px;
}
</style>


// WEBPACK FOOTER //
// src/components/loginAndRegister.vue